import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { RootState } from '@/redux/store';
import { setCtaValue } from './slice';
import { useTimeout } from 'usehooks-ts';

const SESSION_COUNTER_TIMEOUT = 2 * 60 * 1000;

export const useCtaState = () =>
  useAppSelector((state: RootState) => state.ctaSlice);

export const useCtaReportPage = () => {
  const dispatch = useAppDispatch();

  const triggerDispatch = useCallback(
    (page: 'createdCode' | 'statsPage') => {
      dispatch(
        setCtaValue({
          key: page,
          value: true,
        })
      );
    },
    [dispatch]
  );

  return triggerDispatch;
};

export const useCtaReportSession = () => {
  const dispatch = useAppDispatch();
  const { sessionCounter } = useCtaState();

  useTimeout(() => {
    dispatch(
      setCtaValue({
        key: 'sessionCounter',
        value: sessionCounter + 1,
      })
    );
  }, SESSION_COUNTER_TIMEOUT);
};
